export default {
    // local
    // nivoApiUrl: 'http://localhost:3030/nivo',
    // storybookUrl: 'http://localhost:6006/',

    // production
    nivoApiUrl: 'https://nivo-api.herokuapp.com/nivo',
    storybookUrl: 'https://nivo.rocks/storybook/',
}
